import api from "../../api";

export const getStatements = async (query?: string) => {
  if (query) {
    const { data } = await api.get(`billing/partner/transactions?${query}`);
    return data
  } else {
    const { data } = await api.get('billing/partner/transactions');
    return data
  }
}

export const getOpenedStatements = async (query?: string) => {
  if (query) {
    const { data } = await api.get(`billing/partner/transactions?status=1&${query}`);
    return data
  } else {
    const { data } = await api.get('billing/partner/transactions?status=1');
    return data
  }
}

export const getFinishedStatements = async (query?: string) => {
  if (query) {
    const { data } = await api.get(`billing/partner/transactions?status=2&${query}`);
    return data
  } else {
    const { data } = await api.get('billing/partner/transactions?status=2');
    return data
  }
}